import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';
import 'pannellum/src/js/pannellum.js';
import 'pannellum/src/js/libpannellum.js';

export default class SphericalImageComponent extends BaseComponent {
    properties() {
        return {
            source: null,
            yaw: 0,
        };
    }

    connected() {
        // konami code
        this._cowKeys = [
            'ArrowUp',
            'ArrowUp',
            'ArrowDown',
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight',
            'ArrowLeft',
            'ArrowRight',
            'b',
            'a',
        ];
        this._cowCurrent = 0;

        const sphericalImage = this.element.querySelector('.spherical-image');
        window.pannellum?.viewer(sphericalImage, {
            type: 'equirectangular',
            panorama: this.source,
            autoLoad: true,
            compass: true,
            yaw: this.yaw
        });
    }

    events() {
        return {
            window: {
                keydown: (e) => {
                    const key = String.fromCharCode(e.keyCode).toLowerCase();
                    if (
                        this._cowKeys[this._cowCurrent].toLowerCase() === key ||
                        this._cowKeys[this._cowCurrent] === e.key
                    ) {
                        this._cowCurrent++;
                        if (this._cowCurrent >= this._cowKeys.length) {
                            import('./spherical-cow.js').then(
                                ({ default: image }) => {
                                    const sphericalImage = this.element.querySelector('.spherical-image');
                                    window.pannellum?.viewer(sphericalImage, {
                                        type: 'equirectangular',
                                        panorama: image,
                                        autoLoad: true,
                                        compass: true,
                                    });
                                },
                            );

                            this._cowCurrent = 0;
                        }
                    } else {
                        this._cowCurrent = 0;
                    }
                },
            },
        };
    }
}

defineComponent('spherical-image-component', SphericalImageComponent);
